/* 🤖 this file was generated by svg-to-ts */
export const matIconDragHandle: {
  name: 'drag-handle';
  data: string;
} = {
  name: 'drag-handle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z"/></svg>`
};
